export default (seconds) => {
  if (!seconds) return '';

  const secondsInt = Number(seconds);
  const h = Math.floor(secondsInt / 3600);
  const m = Math.ceil(secondsInt / 60) % 60;

  return `${h > 0 ? `${h}h ` : ''}${m}m`;
};
